import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { IPartNumberHistoryResponseDto } from "../models/History";
import { historyService } from "../services/historyService";
import { partNumberHistoryQueryKey } from "./QueryKey";

export function useGetHistoryByPartNumberId(
  partNumberId: number,
): UseQueryResult<IPartNumberHistoryResponseDto> {
  return useQuery({
    queryKey: [partNumberHistoryQueryKey.PART_NUMBER_HISTORY, partNumberId],
    queryFn: () => historyService.getHistoryByPartNumberId(partNumberId),
    enabled: !!partNumberId,
  });
}
